<footer class="footer_custom"  *ngIf="!mobile">
  <div class="content has-text-centered footerDocestate">
    <div class="columns">
    <div class="column-3">
      <span class="et_pb_image_wrap ">
        <img loading="lazy" src="https://www.docestate.com/wp-content/uploads/2020/05/Logo-Docestate.png" alt="Docestate Logo"
             title="Docestate Logo" height="auto" width="150px" srcset="https://www.docestate.com/wp-content/uploads/2020/05/Logo-Docestate.png 200w,
             https://www.docestate.com/wp-content/uploads/2020/05/Logo-Docestate-300x240.png 300w" sizes="(max-width: 200px) 100vw, 200px">
      </span>
    </div>
      <div class="column - 6">
        <div class="columns column_footer">
          <div class="column">
            <ul>
              <li ><div class="column_head"><strong>Unternehmen</strong></div></li>
              <li><a href="https://www.docestate.com/kontakt/">Kontakt</a> </li>
              <li><a href="https://www.docestate.com/ueber-docestate/#referenzen">Referenzen</a> </li>
              <li><a href="https://www.docestate.com/jobs/">Jobs</a> </li>
              <li><a href="https://www.docestate.com/presse/">Presse</a> </li>
            </ul>
          </div>
          <div class="column">
            <ul>
              <li><div class="column_head"><strong>Info</strong></div></li>
              <li><a href="https://www.docestate.com/agb/">AGB</a> </li>
              <li><a href="https://www.docestate.com/datenschutzerklaerung/">Datenschutz</a> </li>
              <li><a href="https://www.docestate.com/impressum/">Impressum</a> </li>
            </ul>
          </div>
          <div class="column">
            <ul>
              <li><div class="column_head"><strong>Produkte</strong></div></li>
              <li><a href="https://www.docestate.com/behoerdenauskuenfte/">Eigentümerlösungen</a> </li>
              <li><a href="https://www.docestate.com/behoerdenloesung/">Behördenlösungen</a> </li>
              <li><a href="https://shop.docestate.com/new_order">Shop</a> </li>
            </ul>
          </div>
          <div class="column">
            <ul>
              <li><div class="column_head"><strong>Zahlmethoden</strong></div></li>
              <li><!--img class="payment" alt="Visacard" src="assets/images/payment_icons/visa.png">
                <img class="payment" alt="Mastercard" src="assets/images/payment_icons/mastercard.png">
                <img class="payment" alt="Amex" src="assets/images/payment_icons/american-express.png" -->
                <img class="payment" alt="Rechnung" src="assets/images/payment_icons/klarna-rechnung.png">
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="line" ></div>
    <div class="columns" style="color: #FFFFFF !important;">
          <div class="column is-2"><p style="font-size: 15px;">© 2021 DocEstate GmbH</p></div>
          <div class="column"><a href="https://www.linkedin.com/company/docestategmbh/"><span><img loading="lazy" src="assets/images/socialMedia_icons/Gruppe%206.svg" alt="LinkedIn" title="LinkedIn" height="auto" width="auto" class="wp-image-229831"></span></a></div>
          <div class="column"><a href="https://www.xing.com/companies/docestategmbh"><span><img loading="lazy" src="assets/images/socialMedia_icons/Gruppe%205.svg" alt="Xing" title="Xing" height="auto" width="auto" class="wp-image-229832"></span></a></div>
          <div class="column"><a href="https://twitter.com/DocEstate_GmbH"><span><img loading="lazy" src="assets/images/socialMedia_icons/Gruppe%207.svg" alt="Twitter" title="Twitter" height="auto" width="auto" class="wp-image-229833"></span></a></div>
    </div>
  </div>
</footer>
